import { useCallback } from 'react';

import { useConferenceStore } from 'store/conference';
import { useCurrentUserStore } from 'store/currentUser';

import { searchParamsNames } from 'constants/searchParamsNames';

import { useConferenceId } from './useConferenceId';

/** Выключение отслеживания уровня звука микрофона, выход из конференции и редирект */
export function useDisableManageMicrophoneLevelAndLeave(page: string) {
    const { disableManageMicrophoneLevel } = useCurrentUserStore();
    const { VOXCallInstance, leaveConference } = useConferenceStore();
    const conferenceId = useConferenceId();

    return useCallback(() => {
        if (VOXCallInstance && conferenceId) {
            disableManageMicrophoneLevel.current().then(() => {
                const searchParams = new URLSearchParams();

                searchParams.append(searchParamsNames.redirectTo, `/conference/${conferenceId}`);
                leaveConference().then(isComplete => {
                    if (isComplete) {
                        window.location.assign(`/${page}?${searchParams}`);
                    }
                });
            });
        }
    }, [conferenceId, VOXCallInstance, leaveConference]);
}
